export enum Mode {
    Both = "B",
    Local = "D",
    Foreign = "F"
}